import serverReducer, { SERVER_INIT } from 'common/server/ducks';
import ProjectRedirect from 'common/server/containers/project_redirect';

export { SERVER_INIT, ProjectRedirect };
export default serverReducer;



// WEBPACK FOOTER //
// ./common/server/index.js